import * as React from "react";
import Component from "../../AbstractComponent";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Constants from "../../../Action/Constants";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import DashboardWillMount from "../../../Middleware/Middlewares/DashboardWillMount";
import UnitServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/UnitServiceStatusTypeContainer";
//import Time from "../../../Time/Time";

export class TabsComponent extends Component {
  protected middlewares: MiddlewareInterface[] = [
    DashboardWillMount
  ];

  public state = {
    chargesCount: 0
  }

  constructor(public props) {
    super(props);
  }

  public switchTab = (event, tabValue) => {
    event

    this.props.dispatch({
      type: Constants.PAGE_DASHBOARD_UPDATE_SWITCH_TAB,
      payload: {
        index: tabValue
      }
    });

    let redirect: string = "overview";


    switch (tabValue) {
      case 0:
        redirect = "overview";
        break;

      case 1:
        redirect = "messages";
        break;

      case 2:
        redirect = "statements";
        break;

      case 3:
        redirect = "charges";
        break;

      case 4:
        redirect = "unused";
        break;

      case 5:
        redirect = "contracts";
        break;

      case 6:
        redirect = "tasks";
        break;

      case 7:
        redirect = "activities";
        break;

      case 8:
        redirect = "notifications";
        break;
    }

    this.redirect(`/app/dashboard/${redirect}`)
  }

  public render() {
    return (
      <Tabs className={`tab tab-simple tab-contains-2 half-size light-tabs scrollable-tabs`}
        value={this.props.app?.dashboardUpdatePageTabIndex}
        onChange={this.switchTab}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab
          value={0}
          label={this.trans("title-start")}
        />

        <Tab
          value={1}
          label={`${this.trans("page/dashboard-tab/messages")} ${this.props.app?.conversations.filter(conversation => conversation?.existsUnreadMessages.forAgency).length > 0 ? `(${this.props.app?.conversations.filter(conversation => conversation?.existsUnreadMessages?.forAgency).length})` : ""}`}
        />

        <Tab
          value={2}
          label={`${this.trans("title-statements")} ${this.props.app?.dashboardStatementsCount > 0 ? `(${this.props.app?.dashboardStatementsCount})` : ""}`}
        />

        <Tab
          value={3}
          label={`${this.trans("title-charges")} ${this.props.app?.dashboardReceivableChargesCount > 0 ? `(${this.props.app?.dashboardReceivableChargesCount})` : ""}`}
        />
        <Tab
          value={4}
          label={`${this.trans("page/dashboard-tab/payments")} ${this.props.app?.dashboardPaymentsCount > 0 ? `(${this.props.app?.dashboardPaymentsCount})` : ""}`}
        />

        <Tab
          value={5}
          label={`${this.trans("contracts")} ${Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id]).filter((unit) => (!unit.removed && (unit.isEmpty || unit.isExpiring || unit.isEnding || unit?.isNeedToAdjustRent) && UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") !== unit?.unitServiceStatus?.id))?.length > 0 ? `(${Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id]).filter((unit) => (!unit.removed && (unit.isEmpty || unit.isExpiring || unit.isEnding || unit?.isNeedToAdjustRent) && UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") !== unit?.unitServiceStatus?.id))?.length})` : ""}`}
        />

        <Tab
          value={6}
          label={`${this.trans("tasks")} ${this.props.app?.dashboardTasksCount > 0 ? `(${this.props.app?.dashboardTasksCount})` : ""}`}
        />

        {
          this.props.app?.settings?.agency?.isActivitiesShown && (
            <Tab
              value={7}
              label={this.trans("page/dashboard-tab/activities")}
            />
          )
        }
        {/* <Tab
          value={8}
          label={`${this.trans("page/dashboard-tab/notifications")} ${this.props.events?.reminders?.filter(r => { return r.reacted || r.removed || r.object?.removed || !r.object?.isActive || ![3, 16].includes(r.eventTypeId) || !Time.todayOrEarlier(r.remindDate) || !r.remindDate || !r.content?.name ? false : true }).length > 0 ? `(${this.props.events?.reminders?.filter(r => { return r.reacted || r.removed || r.object?.removed || !r.object?.isActive || ![3, 16].includes(r.eventTypeId) || !Time.todayOrEarlier(r.remindDate) || !r.remindDate || !r.content?.name ? false : true }).length})` : ""}`}
        /> */}

        {/* <Tab
          value={9}
          label={this.trans("page/dashboard-tab/notes")}
        /> */}
      </Tabs>
    );
  }
}
